import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PreviewFileConfig } from 'src/app/model/preview-file.model';
import { FilesService } from 'src/app/service/files.service';

@Component({
  selector: 'app-pdf-preview-dialog',
  templateUrl: './pdf-preview-dialog.component.html',
  styleUrls: ['./pdf-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfPreviewDialogComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();
  url: SafeResourceUrl;
  loader: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewFileConfig,
    public dialogRef: MatDialogRef<PdfPreviewDialogComponent>,
    private toast: ToastrService,
    private sanitizer: DomSanitizer,
    private filesService: FilesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.showPdfInUI();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private showPdfInUI(): void {
    this._subscriptions.add(
      this.filesService.downloadBlob(this.data.filePath).subscribe(
        (blob) => {
          let file: File;
          const reader = new FileReader();
          reader.onloadend = () => {
            file = new File([blob], this.data.displayName, { type: 'application/pdf' });
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
            this.loader = false;
            this.cdr.detectChanges();
          };
          reader.onerror = () => {
            this.unableToPreviewPdf();
          };
          reader.readAsDataURL(blob);
        },
        () => {
          this.unableToPreviewPdf();
        }
      )
    );
  }

  unableToPreviewPdf(): void {
    this.toast.error('Unable To Preview', 'Error',
      {
        timeOut: 6000,
        positionClass: "toast-top-center",
      });
    this.dialogRef.close();
  }

}
